import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';
import { ThemeOptions, ThemeProvider, createTheme } from '@mui/material/styles';
import { ReactNode } from 'react';
import breakpoints from './breakpoints';
import { MUIPalette } from './mui-palette';
import componentsOverride from './overrides';
import { customShadows } from './shadows';
import shape from './shape';
import typography from './typography';

interface ThemeConfigProps {
  children: ReactNode;
}

const themeOptions: ThemeOptions = {
  palette: MUIPalette,
  typography,
  shape,
  breakpoints,
  direction: 'ltr',
  customShadows,
};

const theme = createTheme(themeOptions);
theme.components = componentsOverride(theme);

export default function ThemeConfig({ children }: ThemeConfigProps) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
